import React from 'react';
import PropTypes from 'prop-types';

import FBIcon from '@mui/icons-material/FacebookRounded';
import MailIcon from '@mui/icons-material/MailOutline';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { NewButton } from '@cdm/quickenloans-library/lib';

import {
    wrapper,
    iconWrapper,
} from './SocialMediaBar.module.scss';

import { socialId } from './Constants';

const socials = {
    facebook: {
        icon: FBIcon,
        id: socialId.fb,
        ariaLabel: 'Facebook',
    },
    twitter: { icon: XIcon, id: socialId.tw, ariaLabel: 'X', },
    email: { icon: MailIcon, id: socialId.em, ariaLabel: 'Email', },
    linkedin: { icon: LinkedInIcon, id: socialId.li, ariaLabel: 'LinkedIn', },
};
const SocialIcon = ({ as }) => 
{
    const SocialIconComp = as;
    return <SocialIconComp />;
};

const SocialMediaBar = ({ links = {}, order = ['facebook', 'twitter', 'linkedin', 'email'], testId = '', className = '' }) =>
{
    const activeLinks = links.map((platform) => platform.channel);

    const socialButtons = order.map(
        (shareName) =>
            activeLinks.includes(shareName) && (
                <NewButton size='medium' variant='outlined' type='icon' onClick={() => window.open(links.find(
                    (platform) => platform?.channel === shareName
                )?.url, '_blank')} testId={`${testId}-${shareName}-button`}>
                    <SocialIcon as={socials[shareName].icon} />
                </NewButton>
            )
    );

    return (
        <div data-testid={testId} className={`${wrapper} ${className}`}>
            <div
                data-testid={testId && `${testId}-button-wrapper`}
                className={iconWrapper}
            >
                {socialButtons}
            </div>
        </div>
    );
};
export default SocialMediaBar;

SocialMediaBar.propTypes = {
    /** Text that appears before the collection of share buttons  */
    links: PropTypes.array,
    /** Array of strings that corespond to the top level keys of the socials object */
    order: PropTypes.array,
    /** Label for Id used in testing */
    testId: PropTypes.string,
    /** Custom Class that can be used to override default styling */
    className: PropTypes.string,
};

SocialIcon.propTypes = {
    as: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};
